import { useEffect } from 'react';

const usePageTitle = (language) => {
  useEffect(() => {
    const titles = {
      fr: 'Garage Ozcanlar | Réparation Auto Evergem | +32 485 93 59 29',
      tr: 'Garage Ozcanlar | Otomobil Tamiri Evergem | +32 485 93 59 29',
      nl: 'Garage Ozcanlar | Auto Reparatie Evergem | +32 485 93 59 29'
    };
    
    document.title = titles[language] || titles.fr;
    
    // Update meta description based on language
    const descriptions = {
      fr: 'Garage Ozcanlar à Evergem - Réparation automobile, entretien, freinage, pneus. Ouvert du lundi au samedi. Tel: +32 485 93 59 29',
      tr: 'Evergem\'de Garage Ozcanlar - Otomobil tamiri, bakım, fren, lastik. Pazartesi-Cumartesi açık. Tel: +32 485 93 59 29',
      nl: 'Garage Ozcanlar in Evergem - Auto reparatie, onderhoud, remmen, banden. Open maandag-zaterdag. Tel: +32 485 93 59 29'
    };
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', descriptions[language] || descriptions.fr);
    }
    
    // Update Open Graph description
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', descriptions[language] || descriptions.fr);
    }
    
  }, [language]);
};

export default usePageTitle;